import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";
import { BiBell, BiRocket, BiSupport } from "react-icons/bi";
import { BsBell, BsGear, BsMenuApp, BsMenuDown, BsMenuUp, BsNodePlusFill, BsRocket } from "react-icons/bs";
import { BiUser } from "react-icons/bi";
import { Dropdown } from 'react-bootstrap';
import { HiLogout } from "react-icons/hi";
import Spinner from "../../Components/Spinner";
import { TbGalaxy, TbNetwork, TbRocket, TbSandbox, TbSql, TbTerminal } from "react-icons/tb";
import { IoMdMenu } from "react-icons/io";
import { BiSearchAlt2 } from "react-icons/bi";
import { HiSparkles } from "react-icons/hi2";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { RiKey2Line, RiSecurePaymentLine } from "react-icons/ri";

function NavBar({ onNavigate, userData, ToggleAiChat }) {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [notificationLoading, setNotificationLoading] = useState(true);
    const [notifications, setNotifications] = useState([]);
    const [visibleSubtitles, setVisibleSubtitles] = useState({});
    const [notificationToRead, setNotificationToRead] = useState(false)
    const [projectName, setProjectName] = useState("")
    const [projectId, setProjectId] = useState("")
    const [hasProject, setHasProject] = useState(false)
    const user_id = sessionStorage.getItem("user_id");
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [isSearchFocused, setIsSearchFocused] = useState(false);


    useEffect(() => {
        if (userData) {
            const notificationsArray = Object.entries(userData.notifications).map(([id, notification]) => ({
                id,
                ...notification
            }));
            setNotifications(notificationsArray);
            setLoading(false);
            setNotificationLoading(false)
            if (userData.projects) {
                setHasProject(true)
                setProjectName(userData.projects.project_name)
                setProjectId(userData.projects._id)
            }
        }
            fetchNotifications()

    }, [userData]);

    const handleLogout = () => {
        setLoading(true);
        sessionStorage.removeItem("user_id");
        document.cookie = "erioon=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        setTimeout(() => {
            navigate(`/login`);
        }, 700);
    };


    const fetchNotifications = async () => {
        setNotificationLoading(true)

        try {
            const response = await fetch("https://backend.erioon.com/get_notifications", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setTimeout(() => {
                setNotificationLoading(false)
            }, 1000);
            const notificationsArray = Object.entries(data.notifications).map(([id, notification]) => ({
                id,
                ...notification
            }));
            setNotifications(notificationsArray);
            const hasNotificationToRead = notificationsArray.some(notification => notification.status === "to_read");
            setNotificationToRead(hasNotificationToRead);

        } catch (error) {
            setNotificationLoading(false)
            console.error("Error fetching notifications:", error);
        }
    };


    const Clear_notifications = async () => {
        const user_id = sessionStorage.getItem("user_id");

        try {
            const response = await fetch("https://backend.erioon.com/clear_notifications", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setNotificationToRead(false);
            fetchNotifications()
        } catch (error) {
            console.error("Error fetching notifications:", error);
        }
    };

    const formatNotificationDate = (timestamp) => {
        const notificationDate = new Date(timestamp);
        const today = new Date();
        const isToday =
            notificationDate.getDate() === today.getDate() &&
            notificationDate.getMonth() === today.getMonth() &&
            notificationDate.getFullYear() === today.getFullYear();

        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const dateString = notificationDate.toLocaleDateString('en-GB', options);
        const timeString = notificationDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

        return isToday ? timeString : dateString;
    };

    const toggleSubtitleVisibility = (id) => {
        setVisibleSubtitles((prev) => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const [copied, setCopied] = useState(false);
    const copyToClipboard = () => {
        const message = projectId;

        navigator.clipboard.writeText(message).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
        });
    };

    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem("theme") === "dark";
    });

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", darkMode ? "dark" : "light");
        localStorage.setItem("theme", darkMode ? "dark" : "light");
    }, [darkMode]);

    const toggleDarkMode = () => {
        setDarkMode(prev => !prev);
    };

    const searchUserData = (query) => {
        const q = query.toLowerCase();
        const results = [];

        const traverse = (obj, path = []) => {
            if (typeof obj !== 'object' || obj === null) return [];

            const matches = [];

            for (const [key, value] of Object.entries(obj)) {
                if (typeof value === 'string' && value.toLowerCase().includes(q)) {
                    matches.push({ keyPath: [...path, key], value });
                } else if (typeof value === 'object') {
                    matches.push(...traverse(value, [...path, key]));
                }
            }

            return matches;
        };

        const entityMap = {
            apis: "API",
            databases: "Database",
            // playboxes: "Playbox",
            deployments: "Deployments",
            network: "IP",
            projects: "Project",
        };

        // Map to track if an item id is already added
        const seenIds = new Set();

        for (const [section, type] of Object.entries(entityMap)) {
            const entries = userData[section];
            if (!entries) continue;

            if (section === 'projects') {
                // Single object, not mapped by ID
                const matches = traverse(entries);
                if (matches.length > 0 && !seenIds.has(entries._id)) {
                    const { keyPath, value } = matches[0]; // only first match
                    results.push({
                        type,
                        key: section,
                        id: entries._id,
                        project_id: entries._id,
                        field: keyPath.join('.'),
                        value,
                    });
                    seenIds.add(entries._id);
                }
            } else {
                // Multiple entries by ID
                for (const [id, entry] of Object.entries(entries)) {
                    if (seenIds.has(id)) continue; // skip if already found

                    const matches = traverse(entry);
                    if (matches.length > 0) {
                        const { keyPath, value } = matches[0]; // only first match
                        results.push({
                            type,
                            key: section,
                            id,
                            project_id: entry.project_id || userData.projects?._id || "unknown",
                            field: keyPath.join('.'),
                            value,
                        });
                        seenIds.add(id);
                    }
                }
            }
        }

        return results;
    };




    useEffect(() => {
        if (searchQuery.length === 0) {
            setSearchResults([]);
            return;
        }

        setLoadingSearch(true);

        const timeout = setTimeout(() => {
            const results = searchUserData(searchQuery);
            setSearchResults(results);
            setLoadingSearch(false);
        }, 300); // debounce

        return () => clearTimeout(timeout);
    }, [searchQuery]);


    const handleResultClick = (result) => {
        const { type, project_id, id, field } = result;
        let path = "";

        switch (type) {
            case "Database":
                path = `/project_panel/${project_id}/databases/${id}/data`;

                const collMatch = field.match(/collections\.([^.]+)\./);
                if (collMatch) {
                    const collectionId = collMatch[1];
                    path += `/${collectionId}`;
                }
                break;

            // case "Playbox":
            //     path = `/project_panel/${project_id}/playbox/${id}/logs`;
            //     break;

            case "Deployments":
                path = `/project_panel/${project_id}/deployments/${id}/logs`;
                break;

            case "API":
                path = `/project_panel/${project_id}/api`;
                break;

            case "IP":
                path = `/project_panel/${project_id}/network`;
                break;

            case "Project":
                path = `/project_panel/${project_id}/databases`;
                break;

            default:
                console.warn("Unknown type:", type);
                return;
        }

        navigate(path);
    };


    const highlightMatch = (text, query) => {
        if (!query) return text;

        const regex = new RegExp(`(${query})`, 'gi');
        const parts = text.split(regex);

        return parts.map((part, i) =>
            regex.test(part) ? (
                <strong key={i} style={{ color: 'var(--azure)' }}>
                    {part}
                </strong>
            ) : (
                part
            )
        );
    };

    const getProjectNameById = (projectId) => {
        const projects = userData.projects || {};

        if (typeof projects === 'object' && !Array.isArray(projects)) {
            if (projects[projectId]) {
                return projects[projectId].project_name || projectId;
            }
        }

        if (projects._id === projectId) {
            return projects.project_name || projectId;
        }

        return projectId;
    };


    return (
        <div className="control_navbar">
            <div className="control_nav_cont">
                {hasProject ? (
                    <>
                        <p className="sidebar_logo fade-in"><i><TbGalaxy /></i></p>
                        <div className="project_header">
                            <span onClick={() => navigate(`/control_panel/projects`)} className="fade-in">{projectName}</span>
                            <span onClick={copyToClipboard} className="project_id_header">{copied ? <i className="fa-solid fa-check fade-in"></i> : <span className="fade-in">{projectId}</span>}</span>
                            {/* <span className="demo_version_header">Demo V1.1</span> */}
                        </div>
                    </>
                ) : (
                    <>
                        <p className="sidebar_logo fade-in" onClick={() => navigate(`/control_panel/projects`)}><i><TbGalaxy /></i> Erioon</p>
                        <div className="project_header">
                            <i className="fa-solid fa-"></i>
                            {/* <span className="demo_version_header">Demo V1.1</span> */}
                        </div>
                    </>
                )}
            </div>
            <div className="search_bar_nav_cont fade-in">
                <div className="search_bar_nav_cont_items">
                    <i><BiSearchAlt2 /></i>
                    <input
                        className="search_bar_nav_cont_input"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onFocus={() => setIsSearchFocused(true)}
                    />
                    {searchQuery.length > 0 && (
                        <span className="close_search_bar_btn" onClick={() => setSearchQuery("")}>
                            <i className="fa-solid fa-x"></i>
                        </span>
                    )}
                </div>
                <div className={`${(isSearchFocused || searchQuery.length > 0) ? "search_bar_nav_cont_result" : "search_bar_nav_cont_result_closed"}`}>
                    <Spinner loading={loadingSearch} />

                    {searchResults.map((res, idx) => (
                        <div
                            key={idx}
                            className="search_result_item"
                            onClick={() => handleResultClick(res)}
                        >
                            <strong>{res.type}</strong> →{" "}
                            <span>{getProjectNameById(res.project_id)}</span> →{" "}
                            <span>{highlightMatch(res.value, searchQuery)}</span>
                        </div>
                    ))}
                    {searchQuery.length > 0 && searchResults.length === 0 && !loadingSearch && (
                        <div className="search_result_item">No results found.</div>
                    )}
                    <div className="standard_searches_cont">
                        <div className="standard_searches_card" onClick={() => navigate(`/project_panel/${projectId}/databases/new_database_nosql`)}>
                            <p>Databases</p>
                            <i><TbGalaxy /></i>
                        </div>
                        <div className="standard_searches_card" onClick={() => navigate(`/project_panel/${projectId}/network`)}>
                            <p>Network</p>
                            <i><TbNetwork /></i>
                        </div>
                        <div className="standard_searches_card" onClick={() => navigate(`/project_panel/${projectId}/access/new_access`)}>
                            <p>Access</p>
                            <i><MdOutlineAdminPanelSettings /></i>
                        </div>
                        <div className="standard_searches_card" onClick={() => navigate(`/project_panel/${projectId}/api`)}>
                            <p>API Keys</p>
                            <i><RiKey2Line /></i>
                        </div>
                        <div className="standard_searches_card" onClick={() => navigate(`/project_panel/${projectId}/settings`)}>
                            <p>Settings</p>
                            <i><BsGear /></i>
                        </div>
                        <div className="standard_searches_card" onClick={() => navigate(`/project_panel/${projectId}/profile`)}>
                            <p>Profile</p>
                            <i><BiUser /></i>
                        </div>
                        <div className="standard_searches_card" onClick={() => navigate(`/control_panel/billing`)}>
                            <p>Billing</p>
                            <i><RiSecurePaymentLine /></i>
                        </div>
                        <div className="standard_searches_card" onClick={() => navigate(`/control_panel/support`)}>
                            <p>Support</p>
                            <i><BiSupport /></i>
                        </div>
                    </div>
                    <p className="close_fast_search" onClick={() => setIsSearchFocused(false)}>Close fast search</p>
                </div>



            </div>

            <div className="control_nav_cont">
                <div className="icon_cont_nav">
                    <Dropdown >
                        <Dropdown.Toggle className="bell">
                            <IoMdMenu />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="custom-dropdown-menu-settings">
                            <div className="settings_center fade-in">
                                <p className="settings_link" onClick={() => onNavigate('settings')}><i><BsGear /></i> {t.settings.settings_title}</p>
                                <p className="settings_link" onClick={() => onNavigate('profile')}><i><BiUser /></i> {t.profile.profile_title}</p>
                                {/* <p className="settings_link" onClick={toggleDarkMode}><i className="fa-solid fa-moon"></i> {darkMode ? "Light Mode" : "Dark Mode"}</p> */}
                                <div className="settings_link last_link" onClick={handleLogout}>
                                    <p><i><HiLogout /></i> Logout</p>
                                </div>
                                {loading ? (
                                    <div className="settings_link_info">
                                        <Spinner loading={true} err={({ message: "", display: "none" })} />
                                    </div>
                                ) : (
                                    userData && (
                                        <div className="settings_link_info" onClick={() => onNavigate('profile')}>
                                            <p className="logout_from_account">{userData.personal_info.name} {userData.personal_info.surname}</p>
                                            <p className="logout_from_account">
                                                {userData.user_type.charAt(0).toUpperCase() + userData.user_type.slice(1)}
                                            </p>
                                        </div>
                                    )
                                )}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                        <Dropdown.Toggle className="bell">
                            <BsBell />
                            {notificationToRead && <div className="bell_to_read"></div>}
                        </Dropdown.Toggle>


                        <Dropdown.Menu className="custom-dropdown-menu-notification">
                            <div className="notifications_center fade-in">
                                <p className="notifications_title" onClick={fetchNotifications}>
                                    Notifications
                                    <i className={`fa-solid fa-rotate ${notificationLoading ? "loading_notification" : ""}`}></i>
                                </p>
                                {notifications.map(notification => (
                                    <div key={notification.id} className="notification">
                                        <div className="notification_only" onClick={() => toggleSubtitleVisibility(notification.id)}>
                                            {notificationToRead ? (<div className="to_read"></div>)
                                                : (<i className={`chevron_notification fa-solid fa-chevron-${visibleSubtitles[notification.id] ? "up" : "down"}`}></i>)
                                            }
                                            <div className="notification_cont" >
                                                <span className="notification_title">{notification.title}
                                                </span>
                                                {visibleSubtitles[notification.id] && (
                                                    <span className="notification_desc">{notification.subtitle}</span>
                                                )}
                                            </div>
                                        </div>
                                        <span className="notification_timestamp">{formatNotificationDate(notification.timestamp)}</span>
                                    </div>
                                ))
                                }
                                {/* ) : (
                                    <p className="no_notifications">Non hai notifiche...</p>
                                )} */}
                                <div className="clear_notifications_cont">
                                    {notificationToRead && <p className="clear_notification" onClick={Clear_notifications}>Clear all notifications</p>}

                                </div>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </div>
    );
}

export default NavBar;
